<template>
  <mobile-responsive-shell :title="title">
    <div v-if="row && row.reference" class="pay-d">
      <div class="pay-d-actions">
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="back">Retour</button>
        <button type="button" class="btn btn-sm btn-primary" @click="goEdit">Modifier</button>
      </div>
      <section class="pay-d-card">
        <h3 class="pay-d-h">Paiement</h3>
        <dl class="pay-kv">
          <div><dt>Réf. ligne</dt><dd>{{ row.reference }}</dd></div>
          <div><dt>Réparation</dt><dd>{{ row.repair_reference }}</dd></div>
          <div><dt>Date</dt><dd>{{ row.date }}</dd></div>
          <div><dt>Montant</dt><dd class="text-success fw-semibold">{{ formatMoney(row.amount) }}</dd></div>
        </dl>
      </section>
      <section class="pay-d-card">
        <h3 class="pay-d-h">Client</h3>
        <p class="mb-0 small">{{ clientLine }}</p>
      </section>
      <section v-if="row.payment" class="pay-d-card">
        <h3 class="pay-d-h">Paiement lié</h3>
        <dl class="pay-kv">
          <div><dt>Ref. paiement</dt><dd>{{ row.payment.reference }}</dd></div>
          <div><dt>Mode</dt><dd>{{ row.payment.paymentMethod }}</dd></div>
          <div v-if="row.payment.checkNumber"><dt>Nº chèque</dt><dd>{{ row.payment.checkNumber }}</dd></div>
          <div v-if="row.payment.bankTransferNumber"><dt>Virement</dt><dd>{{ row.payment.bankTransferNumber }}</dd></div>
        </dl>
      </section>
      <section v-if="row.remark" class="pay-d-card">
        <h3 class="pay-d-h">Remarque</h3>
        <p class="mb-0 small">{{ row.remark }}</p>
      </section>
    </div>
    <p v-else class="text-muted text-center py-4">Chargement…</p>
  </mobile-responsive-shell>
</template>
<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";
export default {
  components: { MobileResponsiveShell },
  computed: {
    ...mapGetters("paymentRepair", { row: "getCurrent" }),
    title() {
      return this.row && this.row.reference ? "Réparation " + this.row.reference : "Détail";
    },
    clientLine() {
      const r = this.row;
      if (!r) return "—";
      if (r.repair && r.repair.customer) return r.repair.customer.fullName || "—";
      if (r.payment && r.payment.customer) {
        return (r.payment.customer.fullName || "") + " " + (r.payment.customer.society || "");
      }
      return "—";
    },
  },
  mounted() {
    const ref = this.$route.params.reference;
    if (ref) this.$store.dispatch("paymentRepair/show", ref);
  },
  methods: {
    formatMoney(v) {
      if (v == null) return "—";
      return parseFloat(v).toFixed(2) + " DH";
    },
    back() {
      this.$router.push({ name: "mobile-payments-repairs-index" });
    },
    goEdit() {
      if (this.row && this.row.reference) {
        this.$router.push({ name: "mobile-payments-repairs-edit", params: { reference: this.row.reference } });
      }
    },
  },
};
</script>
<style scoped>
.pay-d-actions{display:flex;flex-wrap:wrap;gap:.5rem;margin-bottom:1rem}
.pay-d-card{background:#fff;border-radius:12px;padding:.875rem 1rem;margin-bottom:.75rem;box-shadow:0 2px 8px rgba(0,0,0,.06);border:1px solid rgba(0,0,0,.06)}
.pay-d-h{font-size: 1rem;font-weight:700;margin:0 0 .5rem;color:#495057}
.pay-kv{margin:0;display:grid;gap:.35rem}
.pay-kv>div{display:flex;justify-content:space-between;gap:.75rem;font-size: 1.05rem}
.pay-kv dt{margin:0;color:#6c757d;font-weight:500}
.pay-kv dd{margin:0;text-align:right;word-break:break-word}
</style>
